// extracted by mini-css-extract-plugin
export var equalColumn = "_g5-0";